<template>
  <div class="org-register-page">
    <div class="content-container">
      <div class="register-nav">
        <router-link to="/org-selection" class="form__link register-nav__link register-nav__link--back">Back to organization selection</router-link>
        <img
          :src="erriffHealthLogo"
          alt="Erriff Health"
          class="register-nav__logo"
        />
        <router-link to="/login" class="form__link register-nav__link register-nav__link--login">Go to login</router-link>
      </div>
      <div class="page-header">
        <h1 class="page-title">Account Setup</h1>
        <p v-if="selectedOrgTypeTitle" class="page-subtitle">{{ selectedOrgTypeTitle }}</p>
      </div>
      <div v-if="isInvited" class="invitation-notice mb-3 p-3 bg-info text-white rounded">
          <h5><i class="fas fa-envelope"></i> You've been invited!</h5>
          <p class="mb-0">You're registering as a {{ invitationData?.relationType || 'contact' }} for a healthcare team.</p>
        </div>
        <form @submit.prevent="CreateNewAccount()" class="form register-form" id="formContainer" autocomplete="off">
          <!-- Decoy fields: browsers often autofill these instead of the real register inputs. -->
          <div class="autofill-decoy" aria-hidden="true">
            <input type="text" name="fake-username" tabindex="-1" autocomplete="username" />
            <input type="password" name="fake-password" tabindex="-1" autocomplete="current-password" />
          </div>
          <!-- <div class="b-form-group form-groupx row" role="group"> -->
          <div class="mb-2">
            <!--Keyon Adding New Form Here-->
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 new-accountForm"> -->
            <!--Accnt Section-->
            <!-- <div id="AccntSection" class="col-sm-12 col-md-12 col-lg-12 col-xl-12"> -->
            <div v-if="isPatient" class="row mb-2 gx-2">
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="date"
                  name="accountdob"
                  id="Accntdob"
                  class="form-control"
                  v-model="form.dob"
                  required
                />
                <label for="Accntdob" class="profile_label">DOB: <span class="required">*</span></label>
              </div>
            </div>
            <div v-if="isBusiness" class="row mb-2 gx-2">
              <div class="col-md-9 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bname"
                  id="businessname"
                  placeholder="Business Name"
                  class="form-control"
                  v-model="businessInfo.name"
                  required
                />
                <label for="businessname" class="profile_label">Business Name: <span class="required">*</span></label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="EINum"
                  id="einnum"
                  placeholder="EIN Number"
                  class="form-control"
                  v-model="businessInfo.ein"
                  required
                />
                <label for="einnum" class="profile_label">EIN: <span class="required">*</span></label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="firstname"
                  id="AccntFname"
                  value=""
                  class="form-control"
                  placeholder="Required"
                  v-model="form.first"
                  required
                />
                <label for="AccntFname" class="profile_label">First Name: <span class="required">*</span></label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="lastname"
                  id="AccntLname"
                  value=""
                  class="form-control"
                  placeholder="Required"
                  v-model="form.last"
                  required
                />
                <label for="AccntLname" class="profile_label">Last Name: <span class="required">*</span></label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="email"
                  name="accountEmail"
                  id="AccntEmail"
                  placeholder="Account Email"
                  class="form-control"
                  v-model="form.email"
                  autocomplete="off"
                  @keyup="validateEmail"
                  required
                />
                <label for="AccntEmail" class="profile_label">Account Email: <span class="required">*</span></label>
                <form-error
                  v-if="formErrors.email.length != 0"
                  :errors="formErrors.email"
                />
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="reg_acct_uname"
                  id="AccntpUsername"
                  placeholder="Username"
                  class="form-control"
                  v-model="form.login"
                  autocomplete="new-password"
                  autocapitalize="off"
                  autocorrect="off"
                  spellcheck="false"
                  data-lpignore="true"
                  data-1p-ignore
                  data-bwignore
                  data-form-type="other"
                  :readonly="credsReadonly"
                  @focus="unlockCredFields"
                  @keyup="validateUsername"
                  required
                />
                <label for="AccntUsername" class="profile_label">Username: <span class="required">*</span></label>
                <form-error
                  v-if="formErrors.login.length != 0"
                  :errors="formErrors.login"
                />
              </div>
            </div>
            <div class="row mb-2 gx-2">
              
                <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                 
                  <input
                    ref="pwd"
                    :type="showPassword ? 'text' : 'password'"
                    name="reg_acct_pword"
                    id="AccntPWord"
                    placeholder="Password"
                    autocomplete="new-password"
                    data-lpignore="true"
                    data-1p-ignore
                    data-bwignore
                    data-form-type="other"
                    class="form-control"
                    v-model="form.password"
                    :readonly="credsReadonly"
                    @focus="unlockCredFields"
                    @change="validatePassword"
                    required
                  />
                  <button
                    type="button"
                    class="pwd-toggle"
                    @click="togglePassword"
                    @mousedown.prevent
                    :aria-pressed="showPassword"
                    :title="showPassword ? 'Hide password' : 'Show password'"
                    style="background:none; border:none; position:absolute; top:15px; right:16px; cursor:pointer;"
                  >
                  <!-- simple eye / eye-off SVG (swap based on show) -->
                  <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M1 12s4-7 11-7c2 0 3 .5 4 1.3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  </button>
                  <form-error :errors="formErrors.password" />
                  
                
                  <label for="AccntPword" class="profile_label">Password <span class="required">*</span></label>
                </div>
             
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                 ref="pwd2"
                  :type="showPassword ? 'text' : 'password'"
                  name="reg_acct_pword_confirm"
                  id="AccntPWordConfirm"
                  autocomplete="new-password"
                  data-lpignore="true"
                  data-1p-ignore
                  data-bwignore
                  data-form-type="other"
                  placeholder="Confirm Password"
                  class="form-control"
                  v-model="form.password2"
                  :readonly="credsReadonly"
                  @focus="unlockCredFields"
                  @change="confirmPassword"
                  required
                />
                <button
                  type="button"
                  class="pwd-toggle"
                  @click="togglePassword"
                  @mousedown.prevent
                  :aria-pressed="showPassword"
                  :title="showPassword ? 'Hide password' : 'Show password'"
                  style="background:none; border:none; margin-left:-36px; cursor:pointer;margin-left: 359px;margin-top: 0px;position: absolute;top: 15px;cursor: pointer;"
                  >
                  <!-- simple eye / eye-off SVG (swap based on show) -->
                  <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M1 12s4-7 11-7c2 0 3 .5 4 1.3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  </button>
                <form-error :errors="formErrors.password2" />
                <label for="AccntPwordConfirm" class="profile_label"
                  >Confirm Password: <span class="required">*</span></label
                >
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="baddress"
                  id="businessaddr"
                  placeholder="Address"
                  class="form-control"
                  v-model="form.addr"
                  required
                />
                <label for="businessaddr" class="profile_label">Address: <span class="required">*</span></label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bcity"
                  id="businessncity"
                  placeholder="City"
                  class="form-control"
                  v-model="form.city"
                  required
                />
                <label for="businesscity" class="profile_label">City: <span class="required">*</span></label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.state"
                  name="personalstate"
                  id="AccntState"
                  class="form-select"
                  required
                >
                  <option value=""></option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="businessstate" class="profile_label">State: <span class="required">*</span></label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bzip"
                  id="buzip"
                  placeholder="Zip Code"
                  class="form-control"
                  v-model="form.zip"
                  required
                />
                <label for="bzip" class="profile_label">Zip: <span class="required">*</span></label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  class="col-12 form-select"
                  required
                  v-model="form.primaryPhoneType"
                >
                  <option v-for="phone in phoneTypes" :key="phone.id" :value="phone.id">
                    {{ phone.type }}
                  </option>
                </select>
                <label class="profile_label">Phone Type <span class="required">*</span></label>
              </div>
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  id="regphone"
                  class="form-control"
                  placeholder="Required"
                  v-model="form.primaryPhone"
                  required
                />
                <label for="mblphone" class="profile_label">Phone Number <span class="required">*</span></label>
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <select class="col-12 form-select" required v-model="form.pref">
                  <option value="Email" selected>Email</option>
                  <option value="SMS">SMS</option>
                  <option value="Phone">Phone</option>
                  <option value="All">SMS, Phone & Email</option>
                </select>
                <label for="commpref" class="profile_label"
                  >Communication Preference <span class="required">*</span></label
                >
              </div>
            </div>
            <div class="linedivider col-sm-12 col-md-12 col-lg-12"></div>
           <!-- <div v-if="isBusiness" class="row mb-2 gx-2">
              <p>
                Select a package plan that reflects your organization needs.
                <a href="#compareplans" title="Compare Plan Details">here</a>.
              </p>
              <select
                name="packplan"
                id="pckgpln"
                placeholder="Select a Package Plan"
                class="form-select"
                v-model="billingInfo.plan"
              >
                <option value="Basic" selected="selected">EMR Basic</option>
                <option value="Essential">EMR Essential</option>
                <option value="Enterprise">EMR Enterprise</option>
              </select>
            </div>  -->
            <div v-if="isBusiness" class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bilccName"
                  id="billccName"
                  placeholder="Card Holders Name"
                  class="form-control"
                  v-model="billingInfo.cardHolder"
                  required
                />
                <label for="billccName" class="profile_label">Card Holder Name: <span class="required">*</span></label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bilccnumber"
                  id="billccnumber"
                  placeholder="Card Number"
                  class="form-control"
                  v-model="billingInfo.cardNumber"
                  required
                />
                <label for="billccnumber" class="profile_label">Card Number: <span class="required">*</span></label>
              </div>
            </div>
            <div v-if="isBusiness" class="row mb-2 gx-2">
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="billexpDt"
                  id="billexpDt"
                  placeholder="MM/YY"
                  inputmode="numeric"
                  pattern="[0-9]{2}/[0-9]{2}"
                  title="Use MM/YY (e.g. 01/27)"
                  maxlength="5"
                  autocomplete="cc-exp"
                  class="form-control"
                  :value="billingInfo.expDate"
                  @keydown="onCardExpKeydown"
                  @input="onCardExpInput"
                  @blur="validateCardExpDate"
                  required
                />
                <label for="billexpDt" class="profile_label">Expiration Date (MM/YY): <span class="required">*</span></label>
                <p v-if="cardExpError" class="card-exp-error">{{ cardExpError }}</p>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bilcv3"
                  id="billcv3"
                  placeholder="CVV"
                  class="form-control"
                  v-model="billingInfo.cvv"
                  required
                />
                <label for="billcv3r" class="profile_label">CVV: <span class="required">*</span></label>
              </div>
            </div>
            <div v-if="isBusiness" class="row mb-2 gx-2">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <label for="billingsameaddr">Billing Address Same as Mailing Address</label>
                <input
                  type="checkbox"
                  name="billsameaddr"
                  id="billingsameaddr"
                  @change.prevent="PullPersonalAddr()"
                  class="col-sm-12 col-md-6 col-lg-6 f-field"
                  v-model="billAddrCheck"
                />
              </div>
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="billaddr"
                  id="billaddr"
                  placeholder="Billing Address"
                  class="form-control"
                  v-model="billingInfo.billingAddr"
                  required
                />
                <label for="billAddr" class="profile_label">Billing Address: <span class="required">*</span></label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bilcity"
                  id="billCity"
                  placeholder="City"
                  class="form-control"
                  v-model="billingInfo.billingCity"
                  required
                />
                <label for="billCity" class="profile_label">Billing City: <span class="required">*</span></label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="billingInfo.billingState"
                  name="billState"
                  id="billState"
                  class="form-select"
                  required
                >
                  <option value=""></option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="billState" class="profile_label">Billing State: <span class="required">*</span></label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="billzip"
                  id="billzip"
                  placeholder="Billing Zip Code"
                  class="form-control"
                  v-model="billingInfo.billingZip"
                  required
                />
                <label for="billZip" class="profile_label">Billing Zip: <span class="required">*</span></label>
              </div>
            </div>
            <!-- <div class="col-sm-12 col-md-6 col-lg-6">
                <label for="billPhn">Work Phone</label><br />
                <select
                  id="billormblphone"
                  name="billPhone"
                  class="col-sm-12 col-md-6 col-lg-6 f-field"
                >
                  <option selected="selected" value="workphone">Office Phone</option>
                  <option value="Cell">Mobile Phone</option>
                </select>
              </div> -->
            <!--ENdBillling Section-->
            <!-- <div class="workingsign col-sm-12 col-md-12 col-lg-12">
              <p>WORKING - Please be patient.....</p>
            </div> -->
            <div class="col-sm-12 col-md-12 col-lg-12" id="saveformSec">
              <button class="btn btn-primary" type="submit">Create Account</button>
            </div>
            <!-- </div>  -->
            <!--end New FOrm Canvas Here -->
            <!-- <label v-if="!isLoggedIn" class="col-form-label col-md-4" for="admin">Administrator:</label>
            <input v-if="!isLoggedIn" id="admin" type="checkbox" class="col-md-6" v-model="form.admin" />

            <template v-if="form.admin">
              <label class="col-form-label col-md-4" for="npi">NPI: </label>
              <input id="npi" type="number" v-model="form.npi" class="form-control col-md-6" required placeholder="NPI"
                @input="validateNpi">
              <form-error :errors="formErrors.npi" />
            </template>

            <label class="col-form-label col-md-4" for="externid">ID: </label>
            <input id="externid" type="text" v-model="form.externid" class="form-control col-md-6" required
              placeholder="ID" @change="validateId">
            <form-error :errors="formErrors.externid" />


            <label class="col-form-label col-md-4" for="first">First name: </label>
            <input id="first" type="text" v-model="form.first" class="form-control col-md-6" required
              placeholder="First Name" @change="validateName(form.first, FIRST)">
            <form-error :errors="formErrors.first" />

            <label class="col-form-label col-md-4" for="middle">Middle name: </label>
            <input id="middle" type="text" v-model="form.middle" class="form-control col-md-6" placeholder="Middle Name"
              @change="validateName(form.middle, MIDDLE)">
            <form-error :errors="formErrors.middle" />

            <label class="col-form-label col-md-4" for="last">Last name: </label>
            <input id="last" type="text" v-model="form.last" class="form-control col-md-6" required
              placeholder="Last Name" @change="validateName(form.last, LAST)">
            <form-error :errors="formErrors.last" />

            <label class="col-form-label col-md-4" for="login">Username: </label>
            <input id="login" type="text" v-model="form.login" class="form-control col-md-6" required
              placeholder="Enter username" @change="validateUsername">
            <form-error :errors="formErrors.login" />

            <label class="col-form-label col-md-4" for="password">Password: </label>
            <input id="password" v-model="form.password" class="form-control col-md-6" required
              :type="PASSWORD_INPUT_TYPE" placeholder="Enter password" @change="validatePassword">
            <a class="col-form-label col-md-2" @click="togglePasswordType">{{ showHide }}</a>

            <form-error :errors="formErrors.password" />

            <label class="col-form-label col-md-4" for="password2">Confirm password: </label>
            <input id="password2" v-model="form.password2" class="form-control col-md-6" required type="password"
              placeholder="Confirm password" @change="confirmPassword">
            <form-error :errors="formErrors.password2" />

            <label class="col-form-label col-md-4" for="dob">Date of Birth: </label>
            <input id="dob" v-model="form.dob" class="form-control col-md-6" required type="date">
            <form-error :errors="formErrors.dob" />

            <label class="col-form-label col-md-4" for="email">Email: </label>
            <input id="email" v-model="form.email" class="form-control col-md-6" required type="email">
            <form-error :errors="formErrors.email" /> -->

            <!-- TODO: encrypt ssn in backend before uncommenting this  -->
            <!-- <label class="col-form-label col-md-4" for="ssnHead">SSN: </label>
            <input id="ssnHead"
                   v-model="form.ssnHead"
                   class="form-control col-md-2"
                   type="password"
                   v-mask="'###'"
                   @keyup="handleSsnHeadKeyup">
            <input id="ssnMiddle"
                   v-model="form.ssnMiddle"
                   class="form-control col-md-1"
                   type="password"
                   v-mask="'##'"
                   @keyup="handleSsnMiddleKeyup">
            <input id="ssnTail"
                   v-model="form.ssnTail"
                   class="form-control col-md-3"
                   type="text"
                   v-mask="'####'">
            <form-error :errors="formErrors.ssn"/> -->

            <!-- <label class="col-form-label col-md-4" for="gender">Gender: </label>
            <select id="gender" v-model="form.gender" required class="form-control col-md-6">
              <option v-for="(gender, index) in genders" :key="'gender-' + index" :value="gender.id">{{ gender.value }}
              </option>
            </select>
            <form-error :errors="formErrors.gender" />

            <label class="col-form-label col-md-4" for="suffix">Suffix: </label> 
            <select id="suffix" v-model="form.suffix" class="form-control col-md-6">-->
            <!-- @change="validateAffix(AFFIX.SUFFIX)" -->
            <!-- <option v-for="(suffix, index) in suffixes" :key="'suffix-' + index" :value="suffix.id">
                {{ suffix.value }}
              </option>
            </select>
            <form-error :errors="formErrors.suffix" />

            <label class="col-form-label col-md-4" for="title">Title: </label>
            <select id="title" v-model="form.title" class="form-control col-md-6"> -->
            <!-- @change="validateAffix(AFFIX.TITLE)" -->
            <!--  <option v-for="(title, index) in titles" :key="'title-' + index" :value="title.id">
                {{ title.value }}
              </option>
            </select>
            <form-error :errors="formErrors.title" />

            <label class="col-form-label col-md-4" for="addr">Address: </label>
            <input id="addr" v-model="form.addr" class="form-control col-md-6" type="text" @change="validateAddr">
            <form-error :errors="formErrors.addr" />

            <label class="col-form-label col-md-4" for="city">City: </label>
            <input id="city" v-model="form.city" class="form-control col-md-6" type="text" />
            <form-error :errors="formErrors.city" />

            <label class="col-form-label col-md-4" for="state">State: </label>
            <select id="state" v-model="form.state" class="form-control col-md-6">
              <option v-for="(state, index) in states" :key="index" :value="state.abbr">{{ state.abbr }}</option>
            </select>
            <form-error :errors="formErrors.state" />

            <label class="col-form-label col-md-4" for="zip">Zip: </label>
            <input id="zip" v-model="form.zip" class="form-control col-md-6" type="text" v-mask="'#####'" />
            <form-error :errors="formErrors.zip" />

            <label class="col-form-label col-md-4" for="cell">Cell: </label>
            <input id="cell" v-model="cell" class="form-control col-md-6" type="tel" v-mask="'+1 (###) ###-####'" />
            <form-error :errors="formErrors.cell" />

            <label class="col-form-label col-md-4" for="work">Work: </label>
            <input id="work" v-model="work" class="form-control col-md-6" type="tel" v-mask="'+1 (###) ###-####'" />
            <form-error :errors="formErrors.work" />

            <label class="col-form-label col-md-4" for="home">Home: </label>
            <input id="home" v-model="home" class="form-control col-md-6" type="tel" v-mask="'+1 (###) ###-####'" />
            <form-error :errors="formErrors.home" />

            <label class="col-form-label col-md-4" for="home">SSN (last 4): </label>
            <input id="ssn" v-model="ssn" class="form-control col-md-6" type="text" />
            <form-error :errors="formErrors.ssn" />-->
          </div>
        </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/router/index";
import { register, isUserExist, isEmailExist } from "@/api/userApi";
import { post } from "@/store/modules/fsm/index";
import us from "us";
import {
  RequestRegistration,
  RegistrationSuccess,
  RegistrationFailure,
  Continue,
  LoginNavigation,
} from "@/store/modules/fsm/messages";
import FormError from "./FormError";
import { mask } from "vue-the-mask";
import { CURR_API, OTHER_API } from "@/constants/apis";
import $ from "jquery";
import axios from "axios";
import VALIDATION_ERRORS from "@/data/validationErrors";
import { getPasswordPolicyErrors } from "@/utils/passwordPolicy";
import genders from "@/data/genders";
import titles from "@/data/titles";
import suffixes from "@/data/suffixes";
import { isNpiExist } from "../../../api/userApi";
import { h,ref } from "vue";
import { isObject } from "lodash";
import erriffHealthLogo from "@/assets/images/erriff-health-logo.svg";
const password = ref('')
const show = ref(false)
const pwd = ref(null)
const pwd2 = ref(null)
let ein = ref('')


export default {
  name: "RegisterPage",
  components: {
    "form-error": FormError,
  },
  directives: {
    mask,
  },
  data() {
    return {
      erriffHealthLogo,
      states: us.states,
      genders,
      titles,
      suffixes,
      phoneTypes: [
        { id: 1, type: "CELL" },
        { id: 2, type: "HOME" },
        { id: 3, type: "WORK" },
      ],
      billAddrCheck: false,
      businessInfo: {
        name: "",
        ein: "",
      },
      form: {
        isLoggedIn: false,
        noValidation: false,
        admin: false,
        accountType: "",
        npi: "",
        externid: "",
        externid2: "",
        first: "",
        last: "",
        login: "",
        password: "",
        password2: "",
        enrollmentId: null,
        dob: "1970-01-01",
        email: "",
        gender: 1,
        addr: "",
        city: "",
        state: "",
        zip: "",
        primaryPhoneType: null,
        primaryPhone: null,
        ssn: "",
        pref: "Email",
      },
      billingInfo: {
        plan: "Basic",
        cardHolder: "",
        cardNumber: "",
        expDate: "",
        cvv: "",
        billingAddr: "",
        billingCity: "",
        billingState: "",
        billingZip: "",
      },
      nwform: {},
      selectedOrgTypeId: null,
      regPromise: {},
      cell: null,
      work: null,
      home: null,
      formErrors: {},
      showPassword: false,
      isInvited: false,
      invitationData: null,
      inviterName: '',
      // Guards against async keyup validation race conditions.
      emailValidationSeq: 0,
      usernameValidationSeq: 0,
      einError:null,
      cardExpError: "",
      // Keep username/password readonly until focus so browsers skip page-load autofill.
      credsReadonly: true,
    };
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
      isLoggedIn: "isLoggedIn",
    }),
    ssn() {
      return this.form.ssnHead + this.form.ssnMiddle + this.form.ssnTail;
    },
    PASSWORD_INPUT_TYPE() {
      // TODO: when input field is text, browser may remember
      //       input and provide auto complete
      //       need to disable this feature of browser!
      return this.showPassword ? "text" : "password";
    },
     
    /**
     * Toggles the show and hide lable for the password field
     */
    showHide() {
      return !this.showPassword ? "Show" : "Hide";
    },
    isBusiness: function () {
      return !this.isLoggedIn || this.form.accountType === "Business";
    },
    isPatient() {
      return this.form.accountType === "Patient";
    },
    // Get title for register org page by using the route's orgType query parameter
    selectedOrgTypeTitle() {
      const mapBySlug = {
        "medical-practice": "Medical Practice",
        "nursing-agency": "Nursing Agency",
        "care-managing-agency": "Care Managing Agency",
        "home-health-agency": "Home Health Agency",
        "solo-medical-practice": "Solo Medical Practice",
        "independent-nursing": "Independent Nursing",
        "independent-home-health-aide": "Independent Home Health Aide",
        "patient-with-family": "Patient with Family",
        // Patient is the default account type for the register org page
        patient: "Patient",
      };
      const slug = String(this.$route?.query?.orgType || "").trim();
      return mapBySlug[slug] || "";
    },
  },
  watch: {
    cell(newVal, oldVal) {
      // remove +1, spaces, (, ), and - to extract numbers
      this.form.cell = this.extractPhoneNumber(newVal);
    },
    work(newVal, oldVal) {
      // remove +1, spaces, (, ), and - to extract numbers
      this.form.work = this.extractPhoneNumber(newVal);
    },
    home(newVal, oldVal) {
      // remove +1, spaces, (, ), and - to extract numbers
      this.form.home = this.extractPhoneNumber(newVal);
    },
    // While readonly, reject any autofilled credential values.
    "form.login"(val) {
      if (this.credsReadonly && val) this.form.login = "";
    },
    "form.password"(val) {
      if (this.credsReadonly && val) this.form.password = "";
    },
    "form.password2"(val) {
      if (this.credsReadonly && val) this.form.password2 = "";
    },
  },
  created() {
    // initialize errors
    for (let key in this.form) {
      // this.$set(this.formErrors, key, []);
      this.formErrors[key] = []
    }
    this.form.externid = Math.floor(Math.random() * 899999999) + 100000000;
    if (!this.isLoggedIn) {
      this.form.accountType = "Administrator";
    }
    this.selectedOrgTypeId = this.resolveOrgTypeIdFromRoute();
    
    // Handle invitation token if present in URL
    this.handleInvitationToken();
  },
  mounted() {
    // Browsers sometimes autofill after paint; clear credentials if that happens.
    this.clearAutofilledCredentials();
    setTimeout(() => this.clearAutofilledCredentials(), 100);
    setTimeout(() => this.clearAutofilledCredentials(), 500);
  },
  methods: {
    /** Unlock username/password once the user intentionally focuses them. */
    unlockCredFields() {
      this.credsReadonly = false;
    },
    /** Strip any unwanted autofill that landed in the register credential fields. */
    clearAutofilledCredentials() {
      if (this.credsReadonly) {
        this.form.login = "";
        this.form.password = "";
        this.form.password2 = "";
      }
    },
    resolveOrgTypeIdFromRoute() {
      const mapBySlug = {
        "medical-practice": 1,
        "nursing-agency": 2,
        "care-managing-agency": 3,
        "home-health-agency": 4,
        "solo-medical-practice": 5,
        "independent-nursing": 6,
        "independent-home-health-aide": 7,
        "patient-with-family": 8,
        patient: 9,
      };
      const rawId = this.$route?.query?.orgTypeId;
      const parsedId = Number(rawId);
      if (Number.isInteger(parsedId) && parsedId > 0) {
        return parsedId;
      }
      const slug = String(this.$route?.query?.orgType || "").trim();
      return mapBySlug[slug] || null;
    },
    handleInvitationToken() {
      const urlParams = new URLSearchParams(window.location.search);
      const invitationToken = urlParams.get('invitation');
      
      if (invitationToken) {
        this.isInvited = true;
        
        // Pre-fill form with invitation data from URL parameters
        const firstName = urlParams.get('firstName');
        const lastName = urlParams.get('lastName');
        const email = urlParams.get('email');
        const relationType = urlParams.get('relationType');
        
        if (firstName) this.form.first = decodeURIComponent(firstName);
        if (lastName) this.form.last = decodeURIComponent(lastName);
        if (email) this.form.email = decodeURIComponent(email);
        
        // Set account type to Patient for invited contacts
        this.form.accountType = 'Patient';
        
        // Store invitation data
        this.invitationData = {
          token: invitationToken,
          firstName: firstName ? decodeURIComponent(firstName) : '',
          lastName: lastName ? decodeURIComponent(lastName) : '',
          email: email ? decodeURIComponent(email) : '',
          relationType: relationType ? decodeURIComponent(relationType) : ''
        };
        
        // Show invitation message
        this.$swal({
          type: "info",
          title: "Invitation Received",
          text: `You've been invited to join a healthcare team as a ${relationType ? decodeURIComponent(relationType) : 'contact'}. Please complete your registration below.`,
          showConfirmButton: true
        });
      }
    },
    validateEmail() {
      this.form.email = (this.form.email || "").trim();
      this.formErrors.email = [];
      if (!this.form.email) return;

      const seq = ++this.emailValidationSeq;
      isEmailExist(this.form.email)
        .then((exists) => {
          if (seq !== this.emailValidationSeq) return;
          this.formErrors.email = exists ? [VALIDATION_ERRORS.EMAIL_EXISTS] : [];
        })
        .catch((err) => {
          if (seq !== this.emailValidationSeq) return;
          this.formErrors.email = [];
          console.log("Email Validation Error");
          alert(err);
        });
    },
    PullPersonalAddr() {
      if (this.billAddrCheck) {
        this.billingInfo.billingAddr = this.form.addr;
        this.billingInfo.billingCity = this.form.city;
        this.billingInfo.billingState = this.form.state;
        this.billingInfo.billingZip = this.form.zip;
      }
    },
    /** Block non-digit keystrokes in the MM/YY field (allow nav/edit keys). */
    onCardExpKeydown(e) {
      const allowed =
        e.ctrlKey ||
        e.metaKey ||
        e.altKey ||
        [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
        ].includes(e.key);
      if (allowed) return;
      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    },
    /** Mask card expiry as MM/YY; digits only, month clamped to 01-12. */
    onCardExpInput(e) {
      this.cardExpError = "";
      let digits = String(e?.target?.value || "")
        .replace(/\D/g, "")
        .slice(0, 4);
      // First digit of month can only be 0 or 1.
      if (digits.length >= 1 && digits[0] > "1") {
        digits = "0" + digits[0] + digits.slice(1);
        digits = digits.slice(0, 4);
      }
      // Clamp month to 01-12 once both month digits are present.
      if (digits.length >= 2) {
        let month = Number(digits.slice(0, 2));
        if (month === 0) month = 1;
        if (month > 12) month = 12;
        digits = String(month).padStart(2, "0") + digits.slice(2);
      }
      this.billingInfo.expDate =
        digits.length > 2 ? `${digits.slice(0, 2)}/${digits.slice(2)}` : digits;
      // Re-check expiry as soon as MM/YY is complete.
      if (this.billingInfo.expDate.length === 5) {
        this.validateCardExpDate();
      }
    },
    /** True when the card month/year is already past. */
    isCardExpExpired(expDate) {
      const iso = this.formatCardExpForBackend(expDate);
      if (!iso) return false;
      const [y, m] = iso.split("-").map(Number);
      const now = new Date();
      const expEnd = new Date(y, m, 0, 23, 59, 59); // last day of expiry month
      return expEnd < now;
    },
    /** Validate format + reject past expiration dates. */
    validateCardExpDate() {
      const raw = String(this.billingInfo.expDate || "").trim();
      this.cardExpError = "";
      if (!raw) return false;
      if (!/^\d{2}\/\d{2}$/.test(raw)) {
        this.cardExpError = "Enter expiration as MM/YY (numbers only).";
        return false;
      }
      if (!this.formatCardExpForBackend(raw)) {
        this.cardExpError = "Enter a valid month between 01 and 12.";
        return false;
      }
      if (this.isCardExpExpired(raw)) {
        this.cardExpError = "Expiration date cannot be in the past.";
        return false;
      }
      return true;
    },
    /** Convert UI MM/YY into YYYY-MM-DD (last day of that month) for VerifyPaymentInfo / billing insert.
     * Cards are valid through the end of the expiry month, so we persist that last day. */
    formatCardExpForBackend(expDate) {
      const raw = String(expDate || "").trim();
      if (!raw) return "";
      // Already a full/partial ISO date from older flow — coerce day to end of month.
      if (/^\d{4}-\d{2}/.test(raw)) {
        const y = Number(raw.slice(0, 4));
        const m = Number(raw.slice(5, 7));
        if (!y || m < 1 || m > 12) return "";
        const lastDay = String(new Date(y, m, 0).getDate()).padStart(2, "0");
        return `${raw.slice(0, 7)}-${lastDay}`;
      }
      const match = raw.match(/^(\d{1,2})\s*\/\s*(\d{2})$/);
      if (!match) return "";
      const monthNum = Number(match[1]);
      if (monthNum < 1 || monthNum > 12) return "";
      const month = String(monthNum).padStart(2, "0");
      let year = Number(match[2]);
      // Mirror keyon validate_credit_card 2-digit year normalization.
      year += year >= 70 ? 1900 : 2000;
      // new Date(y, m, 0) → last calendar day of month m (1–12).
      const lastDay = String(new Date(year, monthNum, 0).getDate()).padStart(2, "0");
      return `${year}-${month}-${lastDay}`;
    },
    CreatePatient() {
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      let loader = this.$loading.show(
        {},
        {
          after: () => h("div", {}, "Registering your information..."),
        }
      );
      post({ message: RequestRegistration })
        .then(() => {
          this.form.isLoggedIn = this.isLoggedIn;
          this.form.admin = false;
          
          // If this is an invited user, we need to get the inviter's account number from the invitation token
          if (this.isInvited && this.invitationData) {
            // For now, we'll need to implement a method to get inviter info from token
            // This would typically involve a database lookup
            this.form.externid2 = null; // Will be set after registration
          } else {
            this.form.externid2 = this.allData.patient.externId2;
          }
          
          return register(this.form);
        })
        .then((res) => {
          console.log(res);
          alert(`Registration successful. The username is ${this.form.login}.`);
          post({ message: RegistrationSuccess });
        })
        .catch((err) => {
          post({ message: RegistrationFailure });
          alert("Registration failure: " + err);
        })
        .finally(() => {
          loader.hide();
          loader = null;
        });
    },
    async CreateNewAccount() {
     
      if (this.isPatient) {
        this.CreatePatient();
        return;
      }
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      //lets validate cc before we try to send off 
      let validCCInfo = {};
      validCCInfo.cardholdername =  this.billingInfo.cardHolder;
      validCCInfo.cardnumber = this.billingInfo.cardNumber;
      // Backend VerifyPaymentInfo expects YYYY-MM-DD (or MM/YY); normalize UI MM/YY.
      if (!this.validateCardExpDate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: this.cardExpError || "Please enter a valid card expiration date as MM/YY.",
        });
        return;
      }
      validCCInfo.cardexpDt = this.formatCardExpForBackend(this.billingInfo.expDate);
      validCCInfo.cardccv3 = this.billingInfo.cvv;
      //lets see if it first has nine digits Regular expression check
      const validatecc = await this.validateCreditCardInfo(validCCInfo); 
      console.log(validatecc);
     // console.log(validatecc.value);
      if(validatecc !="Valid")
      {
        return; //this should stop overall registration until I wrap up paylooad loogic 
      }

      
      //lets check if EIN has a vlidate format first 
       this.checkEIN();
        if((this.einError !="" || this.einError !=null ) && this.einError !="Valid")
       {
        console.log("EIN ERROR");
         alert(this.einError);
         return;
       }
      //Now Lets Investigate this copany 
       const validateCompanyInfo = await this.validateOrganizationName(this.businessInfo.name,this.businessInfo.ein);
       if( validateCompanyInfo =="Company Account Exist" || validateCompanyInfo =="Not Valid" ||validateCompanyInfo =="Unknown")
       {
         return;
       }
      let loader = this.$loading.show(
        {
          container: this.$refs.pageBody,
        },
        {
          after: () => h("div", {}, `Creating account...`),
        }
      );
      this.nwform.accountnumber = Math.floor(Math.random() * 899999999) + 100000000;
      this.nwform.orgname = this.businessInfo.name;
      this.nwform.einnum = this.businessInfo.ein;
      this.nwform.accountrole = this.form.accountType;
      this.nwform.accountcontact = this.form.first + " " + this.form.last;
      this.nwform.Firstname = this.form.first;
      this.nwform.Lastname = this.form.last;
      this.nwform.prAddress = this.form.addr;
      this.nwform.prCity = this.form.city;
      this.nwform.prState = this.form.state;
      this.nwform.prZip = this.form.zip;
      this.nwform.username = this.form.login;
      this.nwform.password = this.form.password;
      this.nwform.email = this.form.email;
      this.nwform.cell = this.form.primaryPhone;
      this.nwform.companyaddress = this.form.addr;
      this.nwform.companycity = this.form.city;
      this.nwform.companystate = this.form.state;
      this.nwform.companyzip = this.form.zip;
      //billing Addresss Information
      this.nwform.billAddr = this.billingInfo.billingAddr;
      this.nwform.billCity = this.billingInfo.billingCity;
      this.nwform.billState = this.billingInfo.billingState;
      this.nwform.billZip = this.billingInfo.billingZip;
      this.nwform.companyphone = this.form.primaryPhone;
      this.nwform.cardholdername = this.billingInfo.cardHolder;
      this.nwform.cardnumber = this.billingInfo.cardNumber;
      // Persist as YYYY-MM-(last day) so billing.cc_expirationDt matches card validity.
      this.nwform.cardexpDt = this.formatCardExpForBackend(this.billingInfo.expDate);
      this.nwform.cardcvv3 = this.billingInfo.cvv;
      this.nwform.packageLevel = this.billingInfo.plan;
      this.nwform.npi = ""; //do't think we need this actually and can be transfered to acount_user table
      this.nwform.license = ""; //might not actually ned this as well
      this.nwform.emrUserLicense = Math.floor(Math.random() * 89999999);
      this.nwform.licenseState = "Active";
      this.nwform.licenseStrtDate = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      this.nwform.licenseEndDt = "2026-12-01";
      this.nwform.licenseCost = "900.00";
      // Keyon CreateAccount flow still expects Business/Personal semantics.
      this.nwform.accounttype = this.isLoggedIn ? this.form.accountType : "Business";
      this.nwform.orgTypeId = this.selectedOrgTypeId;
      this.nwform.secreteQuestion = "";
      this.nwform.terms = "Yes";

      //lets fill in the Form Object in Order to get a Unique Nine that's been assigned from the backend
      //this.form.data={};
      // this.form.externid="755717554";
      this.form.isLoggedIn = this.isLoggedIn;
      this.form.externid2 = this.nwform.accountnumber;
      if (this.isBusiness) {
        this.form.admin = true;
      }
      register(this.form)
        .then((data) => {
          if (data.externid && data.externid != "") {
            this.nwform.uniqueNineID = data.externid;
            this.nwform.id = data.userId != null && data.userId !== "" ? data.userId : data.externid;
            this.SendAccountInfo()
              .then(() => {
                loader.hide();
                this.$swal({
                  type: "success",
                  title: "Success",
                  text:
                    "This account has been created. You will now be redirected to the login page.",
                }).then(() => {
                  router.push({ name: LoginNavigation });
                });
              })
              .catch((err) => {
                loader.hide();
                console.log(err);
                const msg = err?.message || "Account Not Created Successfully";
                alert(msg.value);
              });
          } else {
            alert("Something wrong with register function");
            console.log(data);
            loader.hide();
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Caught exception for register function");
          loader.hide();
        });
    },
    parseTswebhookJson(data) {
      if (data != null && typeof data === "object" && !Array.isArray(data)) {
        return data;
      }
      if (typeof data === "string") {
        const trimmed = data.trim();
        try {
          return JSON.parse(trimmed);
        } catch (_e) {
          const lastBrace = trimmed.lastIndexOf("{");
          if (lastBrace !== -1) {
            try {
              return JSON.parse(trimmed.slice(lastBrace));
            } catch (_e2) {
              console.log("ParseTswebhookJSON Data Error");
              console.log(_e2);
              return null;
            }
          }
        }
      }
      return null;
    },
   checkEIN() {
      const val = (this.businessInfo.ein || '').replace(/\D/g,'')
      if (!/^\d{9}$/.test(val)) {
        this.einError = 'EIN must be 9 digits'
        return
      }
      else{
        //Adding the else here to add reset the EIN variable so we can pass the conditonal logic test 
        this.einError ="Valid"; 
        return;
      }
     
      
    },
    async validateOrganizationName(companyname,ein)
    {
        const orgname = companyname;
        const einnumber = ein;
        console.log("Value of company Nmae and EIN");
        console.log(orgname);
        console.log(einnumber)
        console.log(ein);
        console.log(companyname);
        const content = {
          Account: {
            API_Meth:"BusinessEINLookup",
            companyname:orgname,
            einnumber:einnumber
          }
        };
        try {
        const res = await axios.post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json" }
        });
    
        if (!res?.data) throw new Error('No response data');
    
        if (res.data.code === "0" && res.data.errorMsg ) {
         console.log("Something Went Wrong WIth COmpany lookup Backend Response");
         console.log(res.data.errorMsg);
         alert("Sorry, We are aware that there is an issue with the application, and we're working to resolve it. Please try again later, or contact support");
          return "Not Valid";
        }
    
        if (res.data.code === "1" && res.data.count ==1) {
          console.log("Does Company Account Exist Already - Yes");//remove after testing
          console.log(res.data.results);
          alert("This company already has an account, please login to access or update your account information.");
          return "Company Account Exist";
        }
        if (res.data.code === "1" && res.data.count ==0) {
          console.log("Does Company Account Exist Already - No");//remove after testing
          console.log(res.data.results);
          return "Company Account Doesn't Exist";
        }
    
        return "Unknown";
      } catch (err) {
        console.error("Axios Error:", err);
        alert("Error with Call, Please try again later");
        return "Error";
      } finally {
        console.log("Reached the end");
      }

    },
    async validateCreditCardInfo(validObj) {
      // extract safely
      const cardnumber = validObj?.cardnumber ?? '';
      const cardexpDt  = validObj?.cardexpDt ?? '';
      const cardccv3   = validObj?.cardccv3 ?? '';
    
      const content = {
        BillingInfo: {
          API_Meth: "VerifyPaymentInfo",
          cardnumber,
          cardexpDt,
          cardccv3
        }
      };
    
      try {
        const res = await axios.post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json" }
        });
    
        if (!res?.data) throw new Error('No response data');
    
        if (res.data.status === "0" && res.data.cardValidated === false) {
          alert(res.data.errorMsg);
          return "Not Valid";
        }
    
        if (res.data.status === "1" && res.data.successMsg === "Card Validation Successfull") {
          console.log(res.data.successMsg);//remove after testing
          return "Valid";
        }
    
        return "Unknown";
      } catch (err) {
        console.error("Axios Error:", err);
        alert("Error with Call, Please try again later");
        return "Error";
      } finally {
        console.log("Reached the end");
      }
    },
    async SendAccountInfo() {
      const content = {
        Account: {
          API_Meth: "CreateAccount",
          Formdata: this.nwform,
        },
      };
      const res = await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      });

      const payload = this.parseTswebhookJson(res?.data);
      if (payload && payload.message === "Account Created Successfully") {
        return payload;
      }

      const errMsg =
        (payload && typeof payload === "object" && (payload.error || payload.message)) ||
        "Account Not Created Successfully";
      throw new Error(String(errMsg));
    },
    randomId() {
      return Math.floor(Math.random() * 899999999) + 100000000;
    },
    extractPhoneNumber(num) {
      const regex = /(\+1)|\s|\(|\)|\-/g;
      return num.replace(regex, "");
    },
    checkIfUserValid() {
      if (!this.form.login || this.form.login.length > 24 || this.form.login.length < 8) {
        this.isUserExist_symbol = "X";
        return;
      }
      isUserExist(this.form.login)
        .then(() => {
          this.isUserExist_symbol = "O";
        })
        .catch((err) => {
          this.isUserExist_symbol = "X";
        });
    },
    togglePassword(event) {
    
    this.showPassword = !this.showPassword;
    // keep focus on the main password input
    this.$nextTick(() => {
      const el = this.$refs.pwd;
      if (el && el.focus) el.focus();
      const ell = this.$refs.pwd2;
      if (ell && ell.focus) ell.focus();
    });
  },
    /**
     * moves focus to next input field
     */
    handleSsnHeadKeyup() {
      if (this.form.ssnHead.length === 3) {
        document.getElementById("ssnMiddle").focus();
      }
    },
    /**
     * moves focus to next input field
     */
    handleSsnMiddleKeyup() {
      if (this.form.ssnMiddle.length === 2) {
        document.getElementById("ssnTail").focus();
      }
    },
    validateSsn() {
      this.formErrors.ssn = [];
      let ssn = this.form.ssn.trim();
      if (ssn.length != 0 || ssn.length != 4 || !/^\d+$/.test(ssn)) {
        // this.$set(
        //   this.formErrors.ssn,
        //   this.formErrors.ssn.length,
        //   VALIDATION_ERRORS.INVALID_SSN
        // );
        this.formErrors.ssn[this.formErrors.ssn.length] = VALIDATION_ERRORS.INVALID_SSN
      }
    },
    validateId() {
      this.formErrors.externid = [];
      let id = this.form.externid.trim();
      if (id.length != 9 || !/^\d+$/.test(id)) {
        // this.$set(
        //   this.formErrors.externid,
        //   this.formErrors.externid.length,
        //   VALIDATION_ERRORS.INVALID_ID
        // );
        this.formErrors.externid[this.formErrors.externid.length] = VALIDATION_ERRORS.INVALID_ID
      }
    },
    /**
     * @param string nameType first, middle, or last
     */
    validateName(name, nameType) {
      //TODO: only letters are allowed at the moment
      const nameRegex = new RegExp("^([a-zA-Z])+([ a-zA-Z])*$");
      let error = null;

      this.form[nameType] = this.form[nameType].trim();
      this.formErrors[nameType] = [];
      if (this.form[nameType] !== "" && !nameRegex.test(this.form[nameType])) {
        error = VALIDATION_ERRORS.LETTERS_ONLY;
        // this.$set(this.formErrors[nameType], this.formErrors[nameType].length, error);
        this.formErrors[nameType][this.formErrors[nameType].length] = error
      }
    },
    validateUsername() {
      const usernameRegex = new RegExp("^([a-zA-Z]|_)+([a-zA-Z0-9_])*$");

      this.form.login = this.form.login.trim();
      this.formErrors.login = [];
      if (!this.form.login) return true;

      // Keep max one error message with clear precedence.
      if (!usernameRegex.test(this.form.login)) {
        this.formErrors.login = [VALIDATION_ERRORS.USERNAME_CHARACTERS];
        return true;
      }
      if (this.form.login.length < 8 || this.form.login.length > 24) {
        this.formErrors.login = [VALIDATION_ERRORS.USERNAME_LENGTH];
        return true;
      }

      const seq = ++this.usernameValidationSeq;
      isUserExist(this.form.login)
        .then((userExists) => {
          if (seq !== this.usernameValidationSeq) return;
          // Assign a single uniqueness message (no stacking from overlapping replies).
          this.formErrors.login = userExists ? [VALIDATION_ERRORS.USERNAME_EXISTS] : [];
        })
        .catch((err) => {
          if (seq !== this.usernameValidationSeq) return;
          this.formErrors.login = [];
          alert(err);
        });
      return true;
    },
    validateNpi() {
      let error = null;
      this.form.npi = this.form.npi.trim();
      this.formErrors.npi = [];

      isNpiExist(this.form.npi)
        .then((npiExists) => {
          if (npiExists) {
            console.log(npiExists);
            error = VALIDATION_ERRORS.NPI_EXISTS;
            // this.$set(this.formErrors.npi, this.formErrors.npi.length, error);
            this.formErrors.npi[this.formErrors.npi.length] = error
          }
        })
        .catch((err) => {
          console.log("isNPI ERROR");
          alert(err);
        });
    },
    validatePassword() {
      this.formErrors.password = getPasswordPolicyErrors(this.form.password, [
        this.form.first,
        this.form.middle,
        this.form.last,
      ]);

      if (this.form.password2 && this.form.password2 !== "") {
        this.confirmPassword();
      }
    },
    confirmPassword() {
      this.formErrors.password2 = [];
      if (this.form.password !== this.form.password2) {
        this.formErrors.password2.push(VALIDATION_ERRORS.PASSWORD_MISMATCH);
      }
    },
    validateAffix(affixType) {
      const affixRegex = new RegExp("^[a-zA-Z]+[\\s\.a-zA-Z]*$");
      let error = null;

      this.form[affixType] = this.form[affixType].trim();
      this.formErrors[affixType] = [];
      if (this.form[affixType] !== "" && !affixRegex.test(this.form[affixType])) {
        error = VALIDATION_ERRORS.NO_SPECIAL_CHARACTERS_OR_NUMBERS;
        // this.$set(this.formErrors[affixType], this.formErrors[affixType].length, error);
        this.formErrors[affixType][this.formErrors[affixType].length] = error
      }
    },
    validateAddr() {
      const addrRegex = new RegExp("^[ 0-9a-zA-Z]+[ \.\-0-9a-zA-Z]*$");
      let error = null;

      this.form.addr = this.form.addr.trim();
      this.formErrors.addr = [];
      if (this.form.addr !== "" && !addrRegex.test(this.form.addr)) {
        error = VALIDATION_ERRORS.NO_SPECIAL_CHARACTERS;
        // this.$set(this.formErrors.addr, this.formErrors.addr.length, error);
        this.formErrors.addr[this.formErrors.addr.length] = error
      }
    },
    validatePhoneNumber(phoneNumberType) {
      //TODO: add and verify
      const phoneNumberRegex = new RegExp("^[0-9]{9}|[0-9]{10}$");
      let error = null;

      this.formErrors[phoneNumberType] = [];
      if (
        this.form[phoneNumberType] &&
        !phoneNumberRegex.test(this.form[phoneNumberType])
      ) {
        error = VALIDATION_ERRORS.INVALID_PHONE_NUMBER;
        // this.$set(
        //   this.formErrors[phoneNumberType],
        //   this.formErrors[phoneNumberType].length,
        //   error
        // );
        this.formErrors[phoneNumberType][this.formErrors[phoneNumberType].length] = error
      }
    },

    /**
     * validates text field (no explicit check for length)
     */
    validateTextField(filed, regex, errMsg) {
      this.form[field] = this.form[field].trim();
      this.formErrors[filed] = [];
      if (this.form[field] !== "" && !regex.test(this.form[filed])) {
        // this.$set(this.formErrors[field], this.formErrors[field].length, errMsg);
        this.formErrors[field][this.formErrors[field].length] = error
      }
    },

    validate() {
      for (let key in this.formErrors) {
        if (this.formErrors[key] && this.formErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },
    capitalizeWords(words) {
      words = words.tolower().split(" ");
    },
    toTitleCase(str) {
      str = str.toLowerCase().split(" ");
      for (let i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }

      return str.join(" ");
    },
    removeExcessiveSpaces(str) {
      return str.trim().replace(/\s+/g, " ");
    },
    sanitizeForm() {
      for (let field in this.form) {
        if ("string" === typeof this.form[field]) {
          this.form[field] = this.removeExcessiveSpaces(this.form[field]);
          if (
            "first" === field ||
            "middle" === field ||
            "last" === field ||
            "addr" === field ||
            "city" === field
          ) {
            this.form[field] = this.toTitleCase(this.form[field]);
          }
        }
      }
      this.form.externid = parseInt(this.form.externid);
    },
    // handleRegistration() {
    //   if (!this.validate()) {
    //     alert("Please correct the errors in the form before submitting.");
    //     return;
    //   }

    //   let loader = this.$loading.show(
    //     {},
    //     {
    //       after: this.$createElement("div", {}, ["Registering your information..."]),
    //     }
    //   );

    //   // sanitize input before submitting
    //   this.sanitizeForm();

    //   post({ message: RequestRegistration })
    //     .then(() => {
    //       this.form.isLoggedIn = this.isLoggedIn;
    //       return register(this.form);
    //     })
    //     .then((username) => {
    //       if (this.isLoggedIn)
    //         alert(`Registration success. The username is: "${username}".`);
    //       else
    //         alert(
    //           `Registration success. Your username is: "${username}". Please find your verification code in your email.`
    //         );
    //       //TODO: redirect to verification page instead
    //       post({ message: RegistrationSuccess });
    //     })
    //     .catch((err) => {
    //       post({ message: RegistrationFailure });
    //       alert("Registration failure: " + err);
    //     })
    //     .finally(() => {
    //       loader.hide();
    //       loader = null;
    //     });
    // },
  },
};
</script>

<style scoped lang="scss">
@import "../../../stylesheets/mixins/alignment";

$color-base: #0c8687;
$color-base-hover: #0a6f70;

.org-register-page {
  min-height: 100vh;
  background: url("../../../assets/images/bg.jpg") no-repeat center fixed;
  background-size: cover;
  padding: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-container {
  background-color: #fff;
  padding: 3rem 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  max-width: 960px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header .page-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: $color-base;
  margin: 0;
}

.page-subtitle {
  font-size: 1rem;
  color: #666;
  margin: 0.75rem 0 0;
}

.register-form {
  width: 100%;
}

/* Off-screen decoys absorb password-manager autofill away from real fields. */
.autofill-decoy {
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.required {
  color: red;
}

.register-form .form-control,
.register-form .form-select {
  border: 1px solid #d0d0d0;
  border-radius: 6px;
}

.register-form .form-control:focus,
.register-form .form-select:focus {
  border-color: $color-base;
  box-shadow: 0 0 0 0.2rem rgba(12, 134, 135, 0.15);
}
.new-accountForm {
  display: flex;
  flex-direction: column;
}
#AccntSection {
  display: flex;
  flex-wrap: wrap;
}
#AccntSection input[type="text"] {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#AccntSection input[type="email"] {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#AccntSection input[type="password"] {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#AccntSection select {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#BusinessSec {
  display: flex;
  flex-direction: column;
}
.businessFormField {
  display: flex;
  flex-wrap: wrap;
}
.businessFormField input[type="text"] {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#billingInfosec {
  display: flex;
  flex-wrap: wrap;
}
#billingsameaddr{
  width:55px;
}
#billingInfosec label {
  font-size: 16px;
}
#billingInfosec input[type="text"],
#billingInfosec input[type="date"] {
  width: 420px;
  height: 42px;
  border-radius: 2px;
  border-color: #003330;
}
.card-exp-error {
  color: #c62828;
  font-size: 0.85rem;
  margin: 0.25rem 0 0;
}
#billingInfosec select {
  width: 420px;
  height: 42px;
  border-radius: 2px;
  border-color: #003330;
}
#billingInfosec #billaddr {
  width: 420px;
}
#billingInfosec #billCity {
  width: 420px;
}
#billingInfosec #billState {
  width: 420px;
}
#billingInfosec #billormblphone {
  width: 420px;
}
.linedivider {
  width: 100%;
  border-width: 1px;
  border-style: dashed;
  margin: 10px 0px;
}
.accntl-msg #formMsg {
  border-style: solid;
  border-color: #003330;
  padding: 40px;
  border-radius: 9px;
  display: none;
}
.formmsg .validation {
  font-family: serif, sans-serif;
  font-style: italic;
  font-weight: 600;
  color: #ff0000;
}
.workingsign {
  display: none;
  background-color: #000000;
  height: 120px;
  padding-top: 30px;
}
.workingsign p {
  font-size: 18px;
  color: #ffffff;
  font-family: sans-serif;
}
.btn--login,
#saveformSec .btn-primary {
  color: #fff;
  background-color: $color-base;
  border-color: $color-base;

  &:hover {
    background-color: $color-base-hover;
    border-color: $color-base-hover;
  }
}

#saveformSec {
  text-align: center;
  margin-top: 1.5rem;
}

.register-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;

  .register-nav__logo {
    width: 100px;
    height: auto;
    flex-shrink: 0;
  }

  .register-nav__link {
    flex: 1 1 0;
  }

  .register-nav__link--back {
    text-align: left;
  }

  .register-nav__link--login {
    text-align: right;
  }

  .form__link {
    color: $color-base;
    font-size: 1.05rem;
    font-weight: 500;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      color: $color-base-hover;
      text-decoration: underline;
    }
  }
}

label,
input {
  font-size: 12px;
  margin-bottom: 10px;
}

input:not([type="checkbox"]) {
  font-size: 14px;
}

input[type="checkbox"] {
  font-size: 4px;
}

@media only screen and (max-width: 768px) {
  .org-register-page {
    padding: 1rem;
  }

  .content-container {
    padding: 2rem 1rem;
    max-height: 95vh;
  }

  .page-header .page-title {
    font-size: 2rem;
  }

  .register-nav {
    flex-direction: column;
    align-items: center;
    text-align: center;

    .register-nav__link {
      flex: 0 0 auto;
      text-align: center;
    }
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
